import React from 'react';

export default function HTML_Lang_Codes() {
  return (
    <div className="HTML_Lang_Codes">
      <h1>HTML Lang Codes</h1>
      <p>This is the placeholder component for <strong>HTML Lang Codes</strong>.</p>
      <p>Link: /html/reference/lang-codes</p>
    </div>
  );
}
